import { render, staticRenderFns } from "./LiquorFoodWine.vue?vue&type=template&id=f9e5515a&scoped=true&"
import script from "./LiquorFoodWine.vue?vue&type=script&lang=js&"
export * from "./LiquorFoodWine.vue?vue&type=script&lang=js&"
import style0 from "./LiquorFoodWine.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LiquorFoodWine.vue?vue&type=style&index=1&id=f9e5515a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e5515a",
  null
  
)

export default component.exports